import Banner from "../components/Banner";
import React, {useState} from "react";
import axios from 'axios';
import Notifications, {notify} from 'react-notify-toast';
import mail from "../assets/MAIL-CASATE2022.jpg";

const Registro = () => {

	const [image, setimage] = useState(null); 
	const [isregistered, setisregistered] = useState(false);


  
  const contenidoBanner = {
    titulo: "Registro",
    texto:
      "Ellos ya están participando por la boda de sus sueños. No se queden fuera y compartan su historia.",
  };

	const states = [
		"Aguascalientes",
		"Baja California",
		"Baja California Sur",
		"Campeche",
		"Chiapas",
		"Chihuahua",
		"Coahuila",
		"Colima",
		"CDMX",
		"Durango",
		"Guanajuato",
		"Guerrero",
		"Hidalgo",
		"Jalisco",
		"México",
		"Michoacan",
		"Morelos",
		"Nayarit",
		"Nuevo Leon",
		"Oaxaca",
		"Puebla",
		"Querétaro",
		"Quintana Roo",
		"San Luis Potosi",
		"Sinaloa",
		"Sonora",
		"Tabasco",
		"Tamaulipas",
		"Tlaxcala",
		"Veracruz",
		"Yucatan",
		"Zacatecas",
	];

	function validationData(){
		if(document.getElementById("email").value === ""|| document.getElementById("marry_one_name").value === ""|| document.getElementById("marry_one_lastname").value === ""|| 
		document.getElementById("phone").value === ""|| document.getElementById("iam").value === ""|| document.getElementById("id_cuentahabiente").value === ""||
		document.getElementById("myAge").value === ""|| document.getElementById("to").value === ""|| document.getElementById("toAge").value === ""|| 
		document.getElementById("history").value === ""|| document.getElementById("picture").value === ""|| document.getElementById("marry_two_name").value === ""||
		document.getElementById("marry_two_lastname").value === ""|| document.getElementById("state").value === ""){
			return false;
		}
		else{
			return true;
		}
	}


	function weddingRegistry(e){
		e.preventDefault();
		let resp = validationData();

		if(resp === true){
			let userData = {
				email: document.getElementById("email").value,
				name: document.getElementById("marry_one_name").value,
				lastname: document.getElementById("marry_one_lastname").value,
				phone: document.getElementById("phone").value,
				gender: document.getElementById("iam").value,
				idCuentahabiente: document.getElementById("id_cuentahabiente").value,
				is_md: 1,
				password: "12345678",
			};
			let casateData = {
				age: document.getElementById("myAge").value,
				iWantToMarry: document.getElementById("to").value,
				herAge: document.getElementById("toAge").value,
				history: document.getElementById("history").value,
				iWantToMarryName: document.getElementById("marry_two_name").value,
				iWantToMarryLastName: document.getElementById("marry_two_lastname").value,
				state:document.getElementById("state").value,
				picture: image,
			};
			let data = {
				casate: casateData,
				user: userData,
				microsite_id:  100,
			}
		
			axios({
				url: 'https://mmkg.net/api/casate',
				method: 'POST',
				headers: {  
					'Content-Type': 'application/json', 
				},
				data,
			})
			.then((response) => {
				console.info("registrado correctamente: ",response);

				if(response.data.status === true){
					notify.show(response.data.message, 'success', 5000);
					setisregistered(true);
				}
				else{
					notify.show(response.data.message, 'warning', 5000);
				}
			})
			.catch((e) => {
				console.error(e);
			})
		}
	}
	function imgOnChange(e){
		let files = e.target.files || e.dataTransfer.files;

		var formData = new FormData();
		formData.append("picture", files[0] );

		axios({
			url: 'https://mmkg.net/api/casate/store-picture',
			method: 'POST',
			headers: {  
				'Content-Type': 'multipart/form-data', 
				'Accept': 'application/json'
			},
			data: formData,
		})
		.then((response) => {
			setimage(response.data.fileName);
		})
		.catch((e) => {
			console.error(e);
		})
	}

  return (
    <>
	{ isregistered === false ? 
      <div className="global__margintop container marginCard bg-white p-4 ">
	  <Notifications options={{zIndex: 200, top: '100px'}} />
		  {/* <div className="containerTelon">
			<div className="telon"></div>
		  </div> */}
        <div className="row justify-content-center mt-2 mt-sm-4">
          <div className="col-12">
			<form onSubmit={weddingRegistry} id="formCasate">
				<div className="registro-card form">
					<div className="row">
						<div className="col">
							<label for="iam">Soy: </label>
							<select id="iam" className="form-control" name="iam" required>
								<option value="">.: Selecciona una opción :.</option>
								<option value="Hombre">Hombre</option>
								<option value="Mujer">Mujer</option>
							</select>
						</div>
						<div className="col">
							<label for="myAge">Mi Edad: </label>
							<input id="myAge" className="form-control" type="number" name="myAge" required/>
						</div>
						<div className="col">
							<label for="to">Me quiero casar con: </label>
							<select id="to" className="form-control" name="to" required>
								<option value="">.: Selecciona una opción :.</option>
								<option value="Hombre">Hombre</option>
								<option value="Mujer">Mujer</option>
							</select>
						</div>
						<div className="col">
							<label for="toAge">Su Edad: </label>
							<input id="toAge" className="form-control" type="number" name="toAge" required/>
						</div>
					</div>
					<div className="row pt-5">
						<div className="col-12 pb-3"><label for="none">Nombre completo de los novios</label></div>
					</div>
					<div className="row">
						<div className="col">
							<input className="form-control" type="text" id="marry_one_name" name="marry_one_name" placeholder="Mi Nombre(s)" required/>
						</div>
						<div className="col">
							<input className="form-control" type="text" id="marry_one_lastname" name="marry_one_lastname" placeholder="Mis Apellidos" required/>
						</div>
					</div>
					<div className="row mt-3">
						<div className="col">
							<input className="form-control" type="text" id="marry_two_name" name="marry_two_name" placeholder="Su Nombre(s)" required/>
						</div>
						<div className="col">
							<input className="form-control" type="text" id="marry_two_lastname" name="marry_two_lastname" placeholder="Sus Apellidos" required/>
						</div>
					</div>
					<div className="row mt-3">
						<div className="col">
							<input className="form-control" type="email" id="email" name="email" placeholder="Correo electrónico" required/>
						</div>
						<div className="col">
							<input className="form-control" type="tel" id="phone" name="phone" placeholder="Número telefónico" required/>
						</div>
					</div>
					<div className="row mt-3">
						<div className="col">
							<input className="form-control" type="text" id="id_cuentahabiente" name="id_cuentahabiente" placeholder="ID de Cuentahabiente" required/>
							<small className="form-text"><a href="https://mmkg.net/registro" target="_blank">SACA AQUÍ TU ID</a></small>
						</div>
						<div className="col">
							<select id="state" className="form-control" name="state" required>
								<option value="">.: Selecciona un estado :.</option>
								{states.map((opt, index) => (
									<option key={index} value={opt}>{opt}</option>
								)) }
							</select>
						</div>
					</div>
					<div className="row mt-3 pt-5">
						<div className="col-12">
							<textarea id="history" className="form-control" name="history" maxLength="1000" placeholder="Tienes 1000 caracteres (letras) para contármela" required></textarea>
						</div>
					</div>
					<div className="row mt-3">
						<div className="col">
							<label for="picture">Suban una foto juntos</label>
							<input id="picture" className="form-control" type="file" name="picture" onChange={imgOnChange} accept="image/*" required/>
						</div>
					</div>
					<div className="row mt-3 justify-content-between">
						<div className="col-12 col-sm-4 pt-5">
							<div className="form-check">
								<input id="terms" className="form-check-input" type="checkbox" name="terms" required/>
								<label for="termas" className="form-check-label">He leido y acepto los <a href="https://www.marthadebayle.com/politica-de-privacidad" target="_blank">términos y condiciones</a></label>
							</div>
						</div>
						<div className="col-12 col-sm-3">
							<button disabled={isregistered === true ? true : false } id="btnRegistro" type="submit" className="btn btn-lg btn-morado float-end mt-3">Registrate y gana la boda</button>
						</div>
					</div>
					
				</div>
			</form>
          </div>
        </div>
      </div>
		:
		<div className="marginCard">
		{/* <div className="containerTelon">
			<div className="telon"></div>
		  </div> */}
			<img className="d-block mx-auto img-fluid" src={mail} alt="Mail Cásate"/>
		</div>
		}
    </>
  );
};

export default Registro;
